export function formatDateTime(value?: number | Date | null) {
  if (!value) return "-";
  const date = value instanceof Date ? value : new Date(value);
  return new Intl.DateTimeFormat("el-GR", {
    dateStyle: "medium",
    timeStyle: "short"
  }).format(date);
}

export function formatDistanceKm(meters?: number | null) {
  if (!meters || !Number.isFinite(meters)) return "0.0 km";
  return `${(meters / 1000).toFixed(1)} km`;
}

export function formatDurationMillis(millis?: number | null) {
  if (!millis || millis <= 0) return "0:00";
  const totalMinutes = Math.floor(millis / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours}h ${minutes.toString().padStart(2, "0")}m` : `${minutes}m`;
}
